"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[9435],{

/***/ 5120:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

/* harmony default export */ __webpack_exports__["Z"] = ({"src":"/_next/static/media/nubrakes-logo-no-text.7abecb29.svg","height":47,"width":94});

/***/ }),

/***/ 6550:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "v": function() { return /* binding */ FAQSection; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var styled_jsx_style__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(60357);
/* harmony import */ var styled_jsx_style__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(styled_jsx_style__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);
/* harmony import */ var _Container__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(3210);
/* harmony import */ var _FAQSection__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(14399);





var FAQSection = function(param) {
    var title = param.title, description = param.description, faqs = param.faqs;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("section", {
        style: {
            backgroundColor: "#ffeee7"
        },
        className: "jsx-aa7c00fd1c17f99f" + " " + "text-center",
        children: [
            (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((styled_jsx_style__WEBPACK_IMPORTED_MODULE_1___default()), {
                id: "aa7c00fd1c17f99f",
                children: ".title.jsx-aa7c00fd1c17f99f{font-size:40px;color:#000;font-weight:700}.description.jsx-aa7c00fd1c17f99f{font-size:18px;color:#7c7c7c;font-weight:400}"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_Container__WEBPACK_IMPORTED_MODULE_3__/* .Container */ .W, {
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h2", {
                        className: "jsx-aa7c00fd1c17f99f" + " " + "title",
                        children: title
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                        className: "jsx-aa7c00fd1c17f99f" + " " + "description",
                        children: description
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: "jsx-aa7c00fd1c17f99f" + " " + "grid md:grid-cols-2 gap-4",
                        children: faqs.map(function(value, index) {
                            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_FAQSection__WEBPACK_IMPORTED_MODULE_4__/* .FAQ */ .Z, {
                                question: value.question,
                                children: value.answer
                            }, index);
                        })
                    })
                ]
            })
        ]
    });
};


/***/ }),

/***/ 14399:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ FAQ; },
/* harmony export */   "v": function() { return /* binding */ FAQSection; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var styled_jsx_style__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(60357);
/* harmony import */ var styled_jsx_style__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(styled_jsx_style__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);
/* harmony import */ var _fortawesome_react_fontawesome__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(67814);
/* harmony import */ var _fortawesome_free_brands_svg_icons_faCcVisa__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(73977);
/* harmony import */ var _fortawesome_free_brands_svg_icons_faCcAmex__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(63543);
/* harmony import */ var _fortawesome_free_brands_svg_icons_faCcDiscover__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(83708);
/* harmony import */ var _Container__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(3210);
/* harmony import */ var react_animate_height__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(68133);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(41664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var _fortawesome_free_solid_svg_icons__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(59417);
/* harmony import */ var _fortawesome_free_brands_svg_icons__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(93024);













var FAQSection = function(param) {
    var title = param.title, description = param.description;
    /*React.useEffect(() => {
    if (iFrameResize)
      iFrameResize({ checkOrigin: false, heightCalculationMethod: 'taggedElement' }, '#SP_cmFDSnceVq2r7aASVGuT')
  }, [iFrameResize])*/ return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("section", {
        className: "jsx-d85d3d4a3bb65347" + " " + "text-center bg-gray-50",
        children: [
            (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((styled_jsx_style__WEBPACK_IMPORTED_MODULE_1___default()), {
                id: "d85d3d4a3bb65347",
                children: ".title.jsx-d85d3d4a3bb65347{font-size:40px;color:#000;font-weight:700}.description.jsx-d85d3d4a3bb65347{font-size:18px;color:#7c7c7c;font-weight:400}@media(max-width:768px){.title.jsx-d85d3d4a3bb65347{font-size:24px;color:#000;font-weight:700}}"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_Container__WEBPACK_IMPORTED_MODULE_4__/* .Container */ .W, {
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        className: "jsx-d85d3d4a3bb65347",
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h2", {
                                className: "jsx-d85d3d4a3bb65347" + " " + "title max-w-xs mx-auto lg:max-w-full",
                                children: title
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                className: "jsx-d85d3d4a3bb65347" + " " + "description",
                                children: description
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        className: "jsx-d85d3d4a3bb65347" + " " + "grid grid-cols-1 md:grid-cols-2 gap-6",
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(FAQ, {
                                question: "What does your quote include?",
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                        className: "jsx-d85d3d4a3bb65347",
                                        children: "At NuBrakes, transparency is at the core of our process. Your quote includes everything: parts, labor, and taxes."
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                        className: "jsx-d85d3d4a3bb65347",
                                        children: "After providing a preliminary quote, your technician will perform a thorough in-person inspection to confirm the recommended repairs, ensuring no surprises."
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(FAQ, {
                                question: "How does the diagnosis work?",
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                        className: "jsx-d85d3d4a3bb65347",
                                        children: "We’ll provide a preliminary diagnosis over the phone or via text to guide the next steps. During your appointment, your technician will perform a thorough inspection and determine the final recommended repairs."
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                        className: "jsx-d85d3d4a3bb65347",
                                        children: "They’ll walk you through their findings, explain everything clearly, and provide a detailed inspection report. You’ll receive the report before making any decisions, ensuring full transparency and control."
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                        className: "jsx-d85d3d4a3bb65347",
                                        children: "Once you’ve reviewed the findings, discussed your options, and authorized the work, we’ll get started right away. With NuBrakes, you’re always in the driver’s seat, and we aim to have you back on the road in no time."
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(FAQ, {
                                question: "Who handles the repairs?",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                    className: "jsx-d85d3d4a3bb65347",
                                    children: "Your vehicle will be serviced by NuBrakes-certified technicians with years of hands-on experience in brake repair. Each technician is a trusted member of our team, ensuring your vehicle is in expert hands."
                                })
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(FAQ, {
                                question: "What type of parts do you use?",
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                        className: "jsx-d85d3d4a3bb65347",
                                        children: "We typically match the brake pad type to your vehicle’s Original Equipment Manufacturer (OEM) specifications, whether ceramic or semi-metallic. We always use Platinum-grade parts or better to ensure optimal braking performance and reliability."
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                        className: "jsx-d85d3d4a3bb65347",
                                        children: "If you have specific preferences or questions about the parts used, we’re happy to discuss bespoke options tailored to your needs. At NuBrakes, your safety and satisfaction are our top priorities."
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(FAQ, {
                                question: "Do you offer a warranty",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("p", {
                                    className: "jsx-d85d3d4a3bb65347",
                                    children: [
                                        "Absolutely! All repairs are backed by our ",
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_6___default()), {
                                            href: "/warranty",
                                            children: "NuBrakes Guarantee"
                                        }),
                                        ", which includes a warranty of up to 2 years / 24,000 miles. You can drive with confidence knowing your brakes are built to last."
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(FAQ, {
                                question: "Do you do any other auto repairs?",
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                        className: "jsx-d85d3d4a3bb65347",
                                        children: "While our primary focus is providing expert brake repairs and brake service, we also offer other essential maintenance items, such as oil changes and battery replacements. Unlike traditional repair shops, we don’t push unnecessary upsells—just honest, straightforward care to keep your vehicle running smoothly."
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                        className: "jsx-d85d3d4a3bb65347",
                                        children: "If you have other service needs, speak to your service advisor—they’ll be happy to help explore how we can assist you."
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(FAQ, {
                                question: "How do I pay for my repairs?",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                    className: "jsx-d85d3d4a3bb65347" + " " + "px-3",
                                    children: [
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                            className: "jsx-d85d3d4a3bb65347" + " " + "answer",
                                            children: "We make payment easy and convenient—no credit card is required to schedule your appointment. Once your service is complete, you can pay on-site using any major credit or debit card. We also offer flexible financing options to make it even easier to get the repairs you need. We do not accept cash as a payment method."
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                            className: "jsx-d85d3d4a3bb65347",
                                            children: [
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_fortawesome_react_fontawesome__WEBPACK_IMPORTED_MODULE_3__/* .FontAwesomeIcon */ .G, {
                                                    icon: _fortawesome_free_brands_svg_icons_faCcVisa__WEBPACK_IMPORTED_MODULE_7__/* .faCcVisa */ .k9,
                                                    className: "mx-1",
                                                    size: "2x"
                                                }),
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_fortawesome_react_fontawesome__WEBPACK_IMPORTED_MODULE_3__/* .FontAwesomeIcon */ .G, {
                                                    icon: _fortawesome_free_brands_svg_icons__WEBPACK_IMPORTED_MODULE_8__/* .faCcMastercard */ .N$R,
                                                    className: "mx-1",
                                                    size: "2x"
                                                }),
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_fortawesome_react_fontawesome__WEBPACK_IMPORTED_MODULE_3__/* .FontAwesomeIcon */ .G, {
                                                    icon: _fortawesome_free_brands_svg_icons_faCcAmex__WEBPACK_IMPORTED_MODULE_9__/* .faCcAmex */ .ve,
                                                    className: "mx-1",
                                                    size: "2x"
                                                }),
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_fortawesome_react_fontawesome__WEBPACK_IMPORTED_MODULE_3__/* .FontAwesomeIcon */ .G, {
                                                    icon: _fortawesome_free_brands_svg_icons_faCcDiscover__WEBPACK_IMPORTED_MODULE_10__/* .faCcDiscover */ .fp,
                                                    className: "mx-1",
                                                    size: "2x"
                                                })
                                            ]
                                        })
                                    ]
                                })
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
var FAQ = function(param) {
    var question = param.question, children = param.children;
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(false), isOpen = ref[0], setIsOpen = ref[1];
    var height = isOpen ? "auto" : 0;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: "flex flex-col flex-grow",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
            className: "text-left rounded-md overflow-hidden border border-gray-200",
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: "px-4 py-3 h-100 bg-white",
                        style: {
                            cursor: "pointer"
                        },
                        onClick: function() {
                            return setIsOpen(!isOpen);
                        },
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                            className: "flex items-center",
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                    className: "flex pr-4",
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_fortawesome_react_fontawesome__WEBPACK_IMPORTED_MODULE_3__/* .FontAwesomeIcon */ .G, {
                                        icon: _fortawesome_free_solid_svg_icons__WEBPACK_IMPORTED_MODULE_11__/* .faPlus */ .r8p,
                                        className: "mx-1",
                                        size: "1x"
                                    })
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                    className: "question mb-0",
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("strong", {
                                        className: "capitalize",
                                        children: question
                                    })
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_animate_height__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
                        duration: 350,
                        height: height,
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            className: "py-4 bg-white",
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                    className: "answer px-3",
                                    children: children
                                })
                            })
                        })
                    })
                ]
            })
        })
    });
};


/***/ }),

/***/ 97257:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "x": function() { return /* binding */ FeatureBySection; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(25675);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
// EXTERNAL MODULE: ./src/components/Container.tsx
var Container = __webpack_require__(3210);
;// CONCATENATED MODULE: ./public/img/nbc-logo@grayscale-1024x266.png
/* harmony default export */ var nbc_logo_grayscale_1024x266 = ({"src":"/_next/static/media/nbc-logo@grayscale-1024x266.716bc1c2.png","height":266,"width":1024,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAACCAMAAABSSm3fAAAAG1BMVEV7e3t/f39MaXE+Pj5JSUlgYGBpaWlBQUFtbW0S8iZ+AAAACXRSTlOkAgCXssAzM8IzDEHQAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAGklEQVR4nGNgZGLjYGVnYmRgZGJgYGFmYgQAAfYALur2UdUAAAAASUVORK5CYII=","blurWidth":8,"blurHeight":2});
;// CONCATENATED MODULE: ./public/img/business-insider-logo.png
/* harmony default export */ var business_insider_logo = ({"src":"/_next/static/media/business-insider-logo.c580027e.png","height":417,"width":1608,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAACCAMAAABSSm3fAAAADFBMVEVubm5vb29ubm5tbW2is7ZZAAAABHRSTlNFN1MVwjbX/AAAAAlwSFlzAAALEwAACxMBAJqcGAAAABRJREFUeJxjYGJgYARhBmZGMIMZAACVABH1GLcLAAAAAElFTkSuQmCC","blurWidth":8,"blurHeight":2});
;// CONCATENATED MODULE: ./public/img/aftermarket-news-logo.png
/* harmony default export */ var aftermarket_news_logo = ({"src":"/_next/static/media/aftermarket-news-logo.758a4f11.png","height":417,"width":1608,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAACCAMAAABSSm3fAAAAG1BMVEVMTExDQ0N9fX11dXVCQkJBQUFISEhpaWmQkJCptCviAAAACXRSTlMDcVNpVUoxKSU5ZKc7AAAACXBIWXMAAAsTAAALEwEAmpwYAAAAGklEQVR4nGNgYGBlYWRkY2Bg4GBmYmZiZwAAAWQAKzWo2m0AAAAASUVORK5CYII=","blurWidth":8,"blurHeight":2});
;// CONCATENATED MODULE: ./public/img/ratchet-wrench-logo@grayscale.png
/* harmony default export */ var ratchet_wrench_logo_grayscale = ({"src":"/_next/static/media/ratchet-wrench-logo@grayscale.dd903de4.png","height":130,"width":500,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAACCAMAAABSSm3fAAAAD1BMVEV3d3d2dnZ3d3d2dnZ0dHQNJw2BAAAABXRSTlNuf12QLh7GRWEAAAAJcEhZcwAACxMAAAsTAQCanBgAAAAaSURBVHicY2BmYGRgYGZgYWBiZGBmZGRiAgAA0wAYqAGTeQAAAABJRU5ErkJggg==","blurWidth":8,"blurHeight":2});
;// CONCATENATED MODULE: ./src/components/FeatureBySection.tsx








var FeatureBySection = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Container/* Container */.W, {
        className: "max-w-full py-5 bg-white px-0",
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "grid grid-cols-2 text-center gap-4 md:grid-cols-5",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "col-span-2 md:col-span-1 mb-2 md:mb-0",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        style: {
                            fontSize: 28,
                            fontWeight: 700
                        },
                        children: "Featured By"
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    style: {
                        height: 40,
                        width: 160
                    },
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                        className: "mx-auto",
                        src: nbc_logo_grayscale_1024x266,
                        alt: "NBC Logo"
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    style: {
                        height: 40,
                        width: 140
                    },
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                        className: "mx-auto",
                        src: business_insider_logo,
                        alt: "Business Insider Logo"
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    style: {
                        height: 40,
                        width: 160
                    },
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                        src: aftermarket_news_logo,
                        alt: "After Market Image Logo"
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    style: {
                        height: 40,
                        width: 140
                    },
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                        className: "mx-auto",
                        src: ratchet_wrench_logo_grayscale,
                        alt: "Ratchet + Wrench Logo"
                    })
                })
            ]
        })
    });
};


/***/ }),

/***/ 32158:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "C": function() { return /* binding */ BuilderTitleSection; },
  "Q": function() { return /* binding */ TitleSection; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(25675);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
// EXTERNAL MODULE: ./node_modules/react-star-rating-component/index.js
var react_star_rating_component = __webpack_require__(64396);
var react_star_rating_component_default = /*#__PURE__*/__webpack_require__.n(react_star_rating_component);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./src/components/Container.tsx
var Container = __webpack_require__(3210);
// EXTERNAL MODULE: ./src/components/Button.tsx
var Button = __webpack_require__(68663);
// EXTERNAL MODULE: ./src/hooks/useQueryParam.tsx
var useQueryParam = __webpack_require__(73401);
// EXTERNAL MODULE: ./node_modules/@fortawesome/react-fontawesome/index.es.js
var index_es = __webpack_require__(67814);
// EXTERNAL MODULE: ./node_modules/@fortawesome/free-solid-svg-icons/index.mjs
var free_solid_svg_icons = __webpack_require__(59417);
;// CONCATENATED MODULE: ./public/img/new_tech_2.jpg
/* harmony default export */ var new_tech_2 = ({"src":"/_next/static/media/new_tech_2.54112927.jpg","height":755,"width":1338,"blurDataURL":"data:image/jpeg;base64,/9j/2wBDAAoHBwgHBgoICAgLCgoLDhgQDg0NDh0VFhEYIx8lJCIfIiEmKzcvJik0KSEiMEExNDk7Pj4+JS5ESUM8SDc9Pjv/2wBDAQoLCw4NDhwQEBw7KCIoOzs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozv/wAARCAAFAAgDASIAAhEBAxEB/8QAFQABAQAAAAAAAAAAAAAAAAAAAAX/xAAeEAABBAEFAAAAAAAAAAAAAAACAAEDBBMSFCIxgf/EABUBAQEAAAAAAAAAAAAAAAAAAAQF/8QAGxEAAgIDAQAAAAAAAAAAAAAAAQIAEQQTIfD/2gAMAwEAAhEDEQA/AJUl0ru1oxxhWhykBY25E2l+38RERkYhR2VclF2sK9U//9k=","blurWidth":8,"blurHeight":5});
;// CONCATENATED MODULE: ./src/components/LandingPage/TitleSection.tsx












var TitleSection = function(param) {
    var phoneNumberTxt = param.phoneNumberTxt, phoneNumber = param.phoneNumber, title = param.title, image = param.image, subheading = param.subheading, callToActionButtonText = param.callToActionButtonText, rating = param.rating, reviewCount = param.reviewCount, _showImage = param.showImage, showImage = _showImage === void 0 ? true : _showImage, showRatings = param.showRatings, buttonColor = param.buttonColor, _showOverlay = param.showOverlay, showOverlay = _showOverlay === void 0 ? false : _showOverlay;
    var query = (0,useQueryParam/* useQueryParam */.W)();
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("section", {
        className: "py-0 text-white",
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "flex flex-col justify-center align-center py-8",
            style: {
                minHeight: "60vh",
                position: "relative",
                width: "100%"
            },
            children: [
                showImage && /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                    src: image !== null && image !== void 0 ? image : new_tech_2,
                    layout: "fill",
                    priority: true,
                    alt: "NuBrakes Mobile Repair Services",
                    objectFit: "cover",
                    objectPosition: "center center"
                }),
                showOverlay && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    style: {
                        backgroundColor: "rgba(0,0,0,.75)",
                        position: "absolute",
                        width: "100%",
                        height: "100%",
                        zIndex: 1,
                        top: 0,
                        left: 0
                    }
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    style: {
                        zIndex: 1
                    },
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Container/* Container */.W, {
                        className: "text-center text-white",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("h1", {
                                className: "title",
                                children: title
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                className: "subheading text-white",
                                children: subheading
                            }),
                            callToActionButtonText && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                    href: {
                                        pathname: "/get-quote/",
                                        query: query
                                    },
                                    passHref: true,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* Button */.zx, {
                                            style: {
                                                paddingTop: 8,
                                                paddingBottom: 8,
                                                paddingLeft: 25,
                                                paddingRight: 25,
                                                backgroundColor: buttonColor !== null && buttonColor !== void 0 ? buttonColor : "#00a1ff"
                                            },
                                            children: callToActionButtonText
                                        })
                                    })
                                })
                            }),
                            phoneNumber && /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                className: "subheading pt-4 text-white",
                                children: [
                                    "Or Call Our Brake Team Now At",
                                    " ",
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                        style: {
                                            color: buttonColor !== null && buttonColor !== void 0 ? buttonColor : "#00a1ff"
                                        },
                                        href: "tel:".concat(phoneNumber),
                                        children: phoneNumberTxt
                                    })
                                ]
                            }),
                            showRatings && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "pt-4 text-white",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)((react_star_rating_component_default()), {
                                        name: "rating",
                                        value: 4.84,
                                        starCount: 5,
                                        starColor: "gold",
                                        editing: false,
                                        renderStarIcon: function() {
                                            return /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* FontAwesomeIcon */.G, {
                                                    icon: free_solid_svg_icons/* faStar */.Tab,
                                                    color: "gold"
                                                })
                                            });
                                        },
                                        renderStarIconHalf: function() {
                                            return /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* FontAwesomeIcon */.G, {
                                                    icon: free_solid_svg_icons/* faStarHalfAlt */.a1Y,
                                                    color: "gold"
                                                })
                                            });
                                        }
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                        className: "subheading text-white",
                                        children: [
                                            "NuBrakes is rated ".concat(rating, "/5 by "),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                                href: {
                                                    pathname: "/reviews/",
                                                    query: query
                                                },
                                                prefetch: false,
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                    style: {
                                                        color: buttonColor !== null && buttonColor !== void 0 ? buttonColor : "#00a1ff",
                                                        textDecoration: "underline"
                                                    },
                                                    children: "".concat(reviewCount, " brake repair customers")
                                                })
                                            })
                                        ]
                                    })
                                ]
                            })
                        ]
                    })
                })
            ]
        })
    });
};
var BuilderTitleSection = function(props) {
    var ref, ref1, ref2, ref3;
    /*#__PURE__*/ return (0,jsx_runtime.jsx)(TitleSection, (0,_object_spread/* default */.Z)({
        rating: (ref = props.builderState) === null || ref === void 0 ? void 0 : (ref1 = ref.state) === null || ref1 === void 0 ? void 0 : ref1.rating,
        reviewCount: (ref2 = props.builderState) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.state) === null || ref3 === void 0 ? void 0 : ref3.reviewCount
    }, props));
};


/***/ })

}]);